<template>
  <div>
    <div class="app-block p-md m-md">
      <h3 class="heading-line title is-4 has-text-weight-light">
        <span :class="'school-title-'+schoolSlug">6 - {{ $t('candidate.process.title') }}</span>
      </h3>


      <div class="has-text-right">
        <transition name="slide-fade">
          <div class="has-text-danger has-text-centered">
            {{ errorMsg }}
          </div>
        </transition>
        <div class="has-text-centered">
          <br>
          <button
              v-if="canSendApplication()"
              :class="'send-application button ' + isLoading"
              @click="sendCandidature"
          >
            {{ $t('candidate.process.send_ecandidature') }}
          </button>
          <b-tooltip
              v-else
              :label="$t('candidate.process.not_complete')"
              animated
              position="is-bottom"
          >
            <button
                class="button"
                disabled
            >
              {{ $t('candidate.process.send_ecandidature') }}
            </button>
          </b-tooltip>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import {mapActions, mapGetters} from 'vuex'

export default {
  props: {
    school: {type: Object},
    candidate: {type: Object}
  },
  data() {
    return {
      isLoading: '',
      errorMsg: ''
    }
  },
  computed: {
    ...mapGetters({
      status: 'candidate/getStatus'
    }),
    application() {
      return this.candidate.applications
    },
    schoolSlug() {
      return this.school ? this.school.slug : ''
    }
  },
  methods: {
    ...mapActions({
      sendProcess: 'candidate/saveProcessMode'
    }),
    toggleLoading: function () {
      this.isLoading = (this.isLoading === '') ? 'is-loading' : ''
    },
    canSendApplication() {

      return this.application.choices_complete
          && (this.application.fees_complete || !this.feesPaymentDisplay())
          && (this.application.motivation_complete || this.candidate.hasAcceptedApplication)


    },
    feesPaymentDisplay() {
      if (this.application.choices && this.application.choices[0]) {
        if (!this.application.choices[0].training_option) {
          return false
        }
        return this.candidate.hasToPayFees
            && this.application.choices[0]
            && this.application.choices[0].training_option.application_fee === 1
      }
      return true
    },
    sendCandidature() {
      this.toggleLoading()
      this.application.process = ['normal']
      this.sendProcess(this.application).then((result) => {
        if (this.status === 200) {
          this.toggleLoading()
          this.$emit('send')
        } else {
          this.toggleLoading()
          this.errorMsg = this.$t('candidate.general.unknown')
        }
      }).catch(() => {
        this.toggleLoading()
        this.errorMsg = this.$t('candidate.general.unknown')
      })
    }
  }
}
</script>

<style scoped>

.radio-group .choice {
  width: 100%;
  height: auto;
  margin-bottom: 1rem;
  padding-bottom: 3rem;
}

.radio-group input[type="radio"]:checked + .choice {
  background-color: #0f1e44;
  color: white;
}

.radio-group input[type="radio"]:checked + .choice strong {
  color: white;
}
</style>
